import { BT_Acquisition_FTTC } from "./bt-acquisition-fttc-plans"

export const plans = {
  BT_Acquisition_FTTC
}
